var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollaborationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.45V14.62",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1201 15.7L12.0001 14.62",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.88 15.7L12 14.62",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7399 7.03003H12.2599C13.9499 7.03003 15.3199 8.40003 15.3199 10.09C15.3199 10.31 15.1499 10.48 14.9299 10.48H9.07994C8.85994 10.48 8.68994 10.31 8.68994 10.09C8.68994 8.40003 10.0599 7.03003 11.7499 7.03003H11.7399Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.03001C13.2482 7.03001 14.26 6.01817 14.26 4.77001C14.26 3.52185 13.2482 2.51001 12 2.51001C10.7518 2.51001 9.73999 3.52185 9.73999 4.77001C9.73999 6.01817 10.7518 7.03001 12 7.03001Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88007 18.04H6.40007C8.09007 18.04 9.46007 19.41 9.46007 21.1C9.46007 21.32 9.29007 21.49 9.07007 21.49H3.21007C2.99007 21.49 2.82007 21.32 2.82007 21.1C2.82007 19.41 4.19007 18.04 5.88007 18.04Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14013 18.05C7.38829 18.05 8.40013 17.0382 8.40013 15.79C8.40013 14.5419 7.38829 13.53 6.14013 13.53C4.89196 13.53 3.88013 14.5419 3.88013 15.79C3.88013 17.0382 4.89196 18.05 6.14013 18.05Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7899 21.4901H14.9399C14.7199 21.4901 14.5499 21.3201 14.5499 21.1001C14.5499 19.4101 15.9199 18.0401 17.6099 18.0401H18.1299C19.8199 18.0401 21.1899 19.4101 21.1899 21.1001C21.1899 21.3201 21.0199 21.4901 20.7999 21.4901H20.7899Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8601 18.05C19.1083 18.05 20.1201 17.0382 20.1201 15.79C20.1201 14.5419 19.1083 13.53 17.8601 13.53C16.6119 13.53 15.6001 14.5419 15.6001 15.79C15.6001 17.0382 16.6119 18.05 17.8601 18.05Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborationIcon);
export default __webpack_public_path__ + "static/media/collaboration_icon.043e78c51a29bc5549b2dabb820aa945.svg";
export { ForwardRef as ReactComponent };